import classnames from "classnames";

type SpinnerChaseProps = {
  className?: string;
};

const SpinnerChase = ({ className }: SpinnerChaseProps) => {
  return (
    <div className={classnames('spinner-chase', className)}>
      <div className="chase-dot" />
      <div className="chase-dot" />
      <div className="chase-dot" />
      <div className="chase-dot" />
      <div className="chase-dot" />
      <div className="chase-dot" />
    </div>
  );
}

export default SpinnerChase;